import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "vote-index-page__buttons" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Szavazok ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Belépek ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Regisztrálok ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Tovább az RTL.hu címlapra ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headline = _resolveComponent("headline")!
  const _component_separator = _resolveComponent("separator")!
  const _component_text_content = _resolveComponent("text-content")!
  const _component_cta_button = _resolveComponent("cta-button")!
  const _component_container = _resolveComponent("container")!
  const _component_rtl_nav = _resolveComponent("rtl-nav")!
  const _component_renderer = _resolveComponent("renderer")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_page = _resolveComponent("page")!

  return (_ctx.vote)
    ? (_openBlock(), _createBlock(_component_page, {
        key: 0,
        is: "section",
        class: "vote-index-page"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_container, {
            type: "section",
            class: "vote-index-page__container"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_headline, { size: "large" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.vote.main.title), 1)
                ]),
                _: 1
              }),
              (_ctx.vote.main.text)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_separator),
                    _createVNode(_component_text_content, {
                      html: _ctx.vote.main.text
                    }, null, 8, ["html"])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_1, [
                (_ctx.user)
                  ? (_openBlock(), _createBlock(_component_cta_button, {
                      key: 0,
                      to: { name: 'vote-form', params: _ctx.vote.$linkParams }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_cta_button, {
                        to: { name: 'vote-login' },
                        theme: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_cta_button, {
                        to: { name: 'vote-signup' },
                        theme: "secondary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ], 64))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_rtl_nav, { position: "sticky-top" }),
          _createVNode(_component_container, { type: "section" }, {
            default: _withCtx(() => [
              _createVNode(_component_renderer, { template: _ctx.contentHtml }, null, 8, ["template"]),
              _createVNode(_component_cta_button, {
                href: _ctx.rtlUrl,
                theme: "tertiary",
                block: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createVNode(_component_arrow_right)
                ]),
                _: 1
              }, 8, ["href"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}